import { storeGet } from '../crud/storage';

export function useAuth() {
  const user = storeGet('user');
  const isLoggedIn = !!(user && user.token);
  return { isLoggedIn, user };
}

export default useAuth;
